import http from '@/services/api/http';

const DEFAULT_TIMELINE = 7;

export default {
  getProfileDetail() {
    return http.get('api/Profile/Detail');
  },
  getMyShares(sort, sortPar) {
    const sorting = sort ? `?sort=${sort}` : '';
    const sortParameter = sorting && sortPar ? `&sortParameter=${sortPar}` : '';
    return http.get(`api/Profile/Shares${sorting}${sortParameter}`);
  },
  getTradeHistory(itemsPerPage, page, marketId, contractId = '', tradeType = '') {
    return http.get(`api/Profile/Trade/History?itemsPerPage=${itemsPerPage}&page=${page}&marketId=${marketId}&contractId=${contractId}&tradeType=${tradeType}`);
  },
  getTransactionHistory(itemsPerPage, page, type = 'ALL', year = '') {
    const url = `api/User/Wallet/History?itemsPerPage=${itemsPerPage}&page=${page}&type=${type}`;
    const restOfQueryString = year ? `&year=${year}` : '';
    return http.get(url.concat(restOfQueryString));
  },
  getMarketPayouts(marketId) {
    return http.get(`api/Profile/Market/${marketId}/Payouts`);
  },
  getContractOffers(contractId) {
    return http.get(`api/Profile/contract/${contractId}/Offers`);
  },
  getContractShares(contractId) {
    return http.get(`api/Profile/contract/${contractId}/Shares`);
  },
  getTradeHistoryMarkets() {
    return http.get('api/Profile/Trade/History/Markets');
  },
  getMarketWatch(sort, sortPar, page = 1, itemsPerPage = 20) {
    const sorting = sort ? `?sort=${sort}` : '';
    const sortParameter = sorting && sortPar ? `&sortParameter=${sortPar}` : '';
    return http.get(`api/Profile/MarketWatch${sorting}${sortParameter}&itemsPerPage=${itemsPerPage}&page=${page}`);
  },
  putMarketWatch(marketId) {
    return http.put(`api/Profile/MarketWatch/${marketId}`);
  },
  deleteMarketWatch(marketId) {
    return http.delete(`api/Profile/MarketWatch/${marketId}`);
  },
  getPortfolioChart(timespan = DEFAULT_TIMELINE) {
    return http.get(`/api/Profile/Portfolio?timespan=${timespan}`);
  },
  putSettings(category, key, value) {
    return http.put(`api/Profile/Settings/Categories/${category}/Keys/${key}/${value}`);
  },
  getAllSettings(categories) {
    return http.get(`/api/Profile/Settings/Categories?categories=${categories}`);
  },
  getNotifications(page = 1, itemsPerPage = 10) {
    return http.get(`api/Profile/Notifications?itemsPerPage=${itemsPerPage}&page=${page}`);
  },
  putNotification(notificationId) {
    return http.put(`api/Profile/Notifications/${notificationId}/read`);
  },
  putNotifications() {
    return http.put('api/Profile/Notifications/markRead');
  },
  postSendInviteEmail(email) {
    const payload = {
      email,
    };
    return http.post('api/Profile/invite/email', payload);
  },
  getUnreadNotificationsCount() {
    return http.get('api/Profile/UnreadNotificationsCount');
  },
  getUserAffiliations() {
    return http.get('api/Profile/Affiliations');
  },
  setUserAffiliations(payload) {
    return http.put('api/Profile/Affiliations', payload);
  },
  removeUserAffiliations(payload) {
    return http.delete('api/Profile/Affiliations', payload);
  },
  getAffiliations(search) {
    return http.get(`api/Profile/Affiliations/Search/${search}`);
  },
};



// WEBPACK FOOTER //
// ./src/services/api/profile.js